module.exports = __webpack_public_path__ + "img/Weapon_20.0cff5fb8.png";